var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.418 25.967v-3.822c0-.976.797-1.767 1.78-1.767h3.593c.472 0 .924.186 1.258.517.334.332.521.781.521 1.25v3.822c-.003.405.158.795.445 1.083.288.288.68.45 1.089.45h2.45a4.325 4.325 0 003.055-1.249 4.262 4.262 0 001.266-3.029V12.334a3.09 3.09 0 00-1.12-2.378l-8.337-6.611a3.872 3.872 0 00-4.936.089L4.334 9.956a3.092 3.092 0 00-1.209 2.378V23.21c0 2.369 1.934 4.289 4.32 4.289H9.84a1.54 1.54 0 001.545-1.522l.034-.011z",
    fill: "#BDBDBD"
  })));
}

export default SvgHomeIcon;